var map = {
	"./add-white.svg": 915,
	"./add.svg": 9475,
	"./alert-circle.svg": 6477,
	"./alert-white.svg": 2576,
	"./arrow-back.svg": 2063,
	"./arrow_drop_down_black.svg": 4166,
	"./broken-image.svg": 7021,
	"./btn-add.svg": 6152,
	"./cart-white.svg": 408,
	"./check-square-black.svg": 4520,
	"./check-square-white.svg": 6550,
	"./check-square.svg": 9034,
	"./check-white.svg": 1530,
	"./clock-grey.svg": 1468,
	"./clock.svg": 236,
	"./close-black.svg": 1944,
	"./close-white.svg": 86,
	"./edit-white.svg": 6,
	"./edit.svg": 9338,
	"./eye-red.svg": 2243,
	"./fullscreen-close.svg": 118,
	"./fullscreen.svg": 2885,
	"./image-white.svg": 361,
	"./image.svg": 213,
	"./inbox-white.svg": 5042,
	"./menu-black.svg": 5305,
	"./menu-white.svg": 1951,
	"./mic.svg": 6871,
	"./minus.svg": 8682,
	"./money-check-black.svg": 2067,
	"./money-check.svg": 3237,
	"./money-white.svg": 8258,
	"./notFound.svg": 5723,
	"./plus-red.svg": 9376,
	"./plus.svg": 4034,
	"./questionMark.svg": 5169,
	"./question_mark_white.svg": 3528,
	"./refresh-white.svg": 4435,
	"./refresh.svg": 3571,
	"./scale-black.svg": 3442,
	"./scale.svg": 7208,
	"./slash-white.svg": 6585,
	"./swap_vert_white_24dp.svg": 8502,
	"./task-white.svg": 3425,
	"./weight.svg": 1686,
	"./whatsapp-black.svg": 6314,
	"./whatsapp_white.svg": 7338,
	"./xCircle-white.svg": 3374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4500;